
import { Vue } from 'vue-class-component';
export default class Contact extends Vue {

}
